import { FetchServiceTitanCredentialResponse } from "./types";
import axiosInstance from "../axiosInstance";

export const fetchServiceTitanCredential = async (
  companyUuid: string,
): Promise<FetchServiceTitanCredentialResponse> => {
  const response = await axiosInstance.get<FetchServiceTitanCredentialResponse>(
    `/api/private/companies/${companyUuid}/service-titan/credentials`,
  );
  return response.data;
};
